export default __webpack_public_path__ + "static/media/card_bg_1.0501a88c.png";